module.exports = __webpack_public_path__ + "img/trash-can-slash.821cde79.svg";